<template>
  <brand-detail :is-view='true'>
  </brand-detail>
</template>

<script>
import BrandDetail from '../components/BrandDetail'
export default {
  name: 'ViewBrand',
  components: {
    BrandDetail
  }
}
</script>

